<ng-container [formGroup]="staffSalaryForm">
  <div class="card-body staff-salary">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="mt-3">Salary</h2>
      <div class="d-flex align-items-center">
        <h2 class="mt-3 px-2">Hourly Pay</h2>
        <mat-slide-toggle
          formControlName="hourly_pay"
          (change)="onChangeHourlyPay()">
        </mat-slide-toggle>
      </div>
    </div>
  </div>
  <h3 class="mt-5">Staff Salary *</h3>
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="input-group mt-4">
        <button class="btn custom-button" type="button">
          <mat-icon class="custom-icon text-dark">attach_money</mat-icon>
        </button>
        <input
          matInput
          currencyMask
          type="text"
          id="name"
          (keyup)="onValueInput($event)"
          formControlName="salary"
          class="form-control"
          name="name"
          />
        @if (hr || this.staffSalaryForm.get('hourly_pay')?.value) {
          <h2  class="mt-2">/hr</h2>
        }
        <app-validation-error
          [formGroup]="staffSalaryForm"
          [controlName]="'salary'"
        ></app-validation-error>
      </div>

      <!-- TODO: The 'tickInterval' property no longer exists -->
      <mat-slider
        class="custom-slider mt-5 ms-3 me-5 w-100"
        discrete
        [displayWith]="formatLabel"
        min="1"
        max="100000"
      #ngSlider><input matSliderThumb formControlName="salary_level" aria-label="units" (input)="onInputChange({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" /></mat-slider>
    </mat-card-content>
  </mat-card>
</ng-container>
